import * as React from 'react';
import type { SVGProps } from 'react';
const SvgPdfGlyph = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 12 12"
    fill="none"
    {...props}
  >
    <g clipPath="url(#pdf-glyph-clip)">
      <path
        d="M11.1679 7.37393C10.3611 6.51119 8.15828 6.8627 7.63086 6.92659C6.85524 6.15968 6.32782 5.23306 6.14165 4.91356C6.42087 4.05082 6.60697 3.18808 6.63806 2.26152C6.63806 1.46267 6.32782 0.6 5.45902 0.6C5.14878 0.6 4.8695 0.791658 4.71435 1.04727C4.34208 1.71835 4.49716 3.06038 5.08668 4.43434C4.74543 5.42485 4.43513 6.38342 3.56639 8.07696C2.66664 8.46027 0.774016 9.35502 0.618865 10.3137C0.556832 10.6011 0.649882 10.8888 0.867066 11.1124C1.08425 11.3042 1.36347 11.4 1.64275 11.4C2.79071 11.4 3.90764 9.77049 4.68333 8.39639C5.33488 8.17278 6.35877 7.85321 7.38266 7.66149C8.59264 8.7479 9.64755 8.90761 10.2061 8.90761C10.9507 8.90761 11.2299 8.58811 11.323 8.30049C11.4781 7.98106 11.385 7.62954 11.1679 7.37393ZM10.3922 7.91717C10.3611 8.14084 10.082 8.36444 9.58552 8.23667C8.996 8.07696 8.46858 7.78933 8.00319 7.40587C8.40655 7.34192 9.30623 7.24609 9.95785 7.37393C10.2061 7.43782 10.4543 7.5976 10.3922 7.91717ZM5.21082 1.33483C5.27285 1.239 5.36597 1.17511 5.45902 1.17511C5.73823 1.17511 5.80027 1.52655 5.80027 1.81418C5.76925 2.48526 5.64512 3.1562 5.428 3.79527C4.96255 2.51714 5.05567 1.62238 5.21082 1.33483ZM5.14878 7.53372C5.39698 7.02249 5.7383 6.12774 5.86237 5.74428C6.14159 6.2235 6.60697 6.79875 6.85524 7.05436C6.85524 7.08638 5.89339 7.27803 5.14878 7.53372ZM3.31819 8.81185C2.60461 10.026 1.85994 10.7929 1.45659 10.7929C1.39455 10.7929 1.33245 10.7609 1.27042 10.729C1.1773 10.665 1.14628 10.5692 1.1773 10.4414C1.27042 9.99409 2.07712 9.38697 3.31819 8.81185Z"
        fill="#fff"
      />
    </g>
    <defs>
      <clipPath id="pdf-glyph-clip">
        <rect width={12} height={12} fill="#fff" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgPdfGlyph;
